import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.jsx'
import Auth0ProviderWithNavigate from './providers/Auth0ProviderWithNavigate.jsx'
import ScrollToTop from './components/ScrollToTop.jsx'
import { ToastProvider } from './context/ToastContext.jsx'
import { ThemeProvider } from './context/ThemeContext.jsx'
import './index.css'

const domain = import.meta.env.VITE_AUTH0_DOMAIN
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID
const audience = import.meta.env.VITE_AUTH0_AUDIENCE
const authEnabled = Boolean(domain && clientId)

if (!authEnabled) {
  console.warn(
    'Auth0 environment variables are missing. Login will be disabled until VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID are set.',
  )
}

const rootEl = document.getElementById('root')

const tree = (
  <StrictMode>
    <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <ThemeProvider>
        <Auth0ProviderWithNavigate domain={domain} clientId={clientId} audience={audience}>
          <ToastProvider>
            <App authEnabled={authEnabled} />
          </ToastProvider>
        </Auth0ProviderWithNavigate>
      </ThemeProvider>
    </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
)

// Always client-render with createRoot. Prerendered routes (see
// scripts/prerender.mjs) ship real markup inside #root for crawlers/social
// scrapers and instant first paint; createRoot replaces it on mount. We do NOT
// hydrateRoot: the app's first client frame is non-deterministic (Auth0 + theme
// init), which would cause hydration mismatches (React #418). Crawlers never run
// JS, so they still get the static HTML — the SEO goal is met either way.
createRoot(rootEl).render(tree)
